import * as React from "react";

import { toDate, useDateTimeFormat } from "@/shared/datetime";

import styles from "./MessageTimestamp.module.css";

interface MessageTimestampProps {
  /** ISO instant the message was created. */
  created: string;
}

/**
 * The "sent at" caption under a chat message: time only when sent today,
 * date + time otherwise, in the viewer's date-format preference; the full
 * seconds + timezone instant rides in the tooltip. The parent row handles
 * alignment and hover reveal. Not to be confused with the robot-data
 * timestamps embedded in markdown replies (`Timestamp`).
 */
export function MessageTimestamp({
  created,
}: MessageTimestampProps): React.ReactElement | null {
  const format = useDateTimeFormat();
  const date = toDate(created);
  if (date === null) {
    // Same contract as `FormattedDateTime`: a wire value that doesn't parse
    // renders nothing rather than throwing in the transcript.
    return null;
  }
  return (
    <time
      dateTime={created}
      title={format.format(date, { time: "seconds", timeZone: true })}
      className={styles.timestamp}
    >
      {format.format(date, { time: "minutes", omitDateIfToday: true })}
    </time>
  );
}
